<template>
  <div>
    <div class="toolbar">
      <div class="insert-link-section">
        <!--
                        <input v-on:click="newRestoreSel" id="restoreButton" type="button" value="Restore selection" unselectable="on" class="unselectable"> -->

        <div
          :class="'dre-toolbar-popup-wrapper ' + fixedToolbar"
          :style="'top: ' + scrollTop + ';'"
          id="linkSection"
        >
          <button
            class="unselectable dre-btn"
            id="saveButton"
            unselectable="on"
            v-on:click.prevent="toggleLinkPopup"
          >
            <!-- <icon-base icon-name="link-icon"><link-icon /></icon-base> -->
            Link
          </button>
          <button
            :class="'cursor-toolbar unselectable dre-btn ' + cursorToolbar"
            id="unlink"
            unselectable="on"
            v-on:click.prevent="removeAnchor"
          >
            <!-- <icon-base icon-name="unlink-icon"><unlink-icon /></icon-base> -->
            Unlink
          </button>
          <button
            class="unselectable dre-btn"
            id="insert-code"
            unselectable="on"
            v-on:click.prevent="showCodeInserter"
          >
            Code
          </button>
          <button
              class="dre-btn"
              v-on:click.prevent="(e) => updateNote(saveAndClose = true)"
          >
            Done
          </button>
          <button
            class="dre-btn"
            v-if="this.$store.state.notes.has_changed"
            v-on:click.prevent="(e) => updateNote(saveAndClose = false)"
          >
            Save
          </button>
          <popup
            :cb="focusOnInput"
            @close="showLinkPopup = false"
            modalName="linkPopup"
            v-if="showLinkPopup"
          >
            <div id="linkInserter" slot="body">
              <div class="mb-1">
                <input
                  class="input-text-1 focus:shadow-outline focus:outline-0"
                  id="anchorHref"
                  name="anchorHref"
                  placeholder="http://"
                  type="text"
                  v-model="anchorHref"
                />
              </div>
              <div class="mb-2">
                <label for="anchorTarget">Open in new tab</label>&nbsp;
                <input
                  id="anchorTarget"
                  name="anchorTarget"
                  type="checkbox"
                  v-model="checked"
                />
              </div>
              <div>
                <input
                  class="button-1 w-full"
                  type="button"
                  v-on:click="insertAnchor"
                  value="Insert"
                />
              </div>
            </div>
          </popup>
        </div>
      </div>
    </div>
    <div :id="drid" :ref="drid" class="dreditor" contenteditable="true"></div>

    <popup
      @close="showCode = false"
      modalName="codeInserterPopup"
      v-if="showCode"
    >
      <div slot="body">
        <textarea
          class="w-full border border-gray mb-1"
          id="codeBlock"
        ></textarea>
        <input
          class="button-1 w-full"
          type="button"
          v-on:click="insertCode"
          value="Insert"
        />
      </div>
    </popup>
    <!-- <input type="button"  unselectable="on" value="Insert Link" v-on:click="showLinkInserter" /> -->
  </div>
</template>

<script>
import Popup from "./ui/Popup.vue";
import rangy from "rangy";
import "rangy/lib/rangy-selectionsaverestore";
import debounce from "debounce";
import sanitizeHTML from "sanitize-html";
// import IconBase from './ui/IconBase.vue';
// import LinkIcon from './ui/icons/LinkIcon.vue';
// import UnlinkIcon from './ui/icons/UnlinkIcon.vue';
// import CodeIcon from './ui/icons/CodeIcon.vue';

export default {
  name: "dreditor",
  model: {
    prop: "html",
    event: "html"
  },
  props: {
    html: {
      type: String,
      default: ""
    },
    content: String,
    drid: String,
    placeholder: {
      type: String,
      default: "Enter text..."
    },
    updateNote: {
      type: Function,
      required: true
    }
  },
  components: {
    Popup
    // IconBase,
    // LinkIcon,
    // CodeIcon,
    // UnlinkIcon,
  },
  data() {
    return {
      showing: false,
      selRange: "",
      savedSel: null,
      cursorToolbar: false,
      showCode: false,
      showLinkPopup: false,
      anchorHref: "",
      checked: true,
      fixedToolbar: false,
      scrollTop: "initial"
    };
  },
  mounted() {
    document.addEventListener("keydown", this.handleHitEnter, true);
    this.unwatch = this.$watch("html", this.syncHTML, { immediate: true });
    this.$refs[this.drid].addEventListener("input", this.onInput);
    window.addEventListener("scroll", this.scroll);
    // Check to see if the icon for removing links should be shown
    document.addEventListener("click", this.showRemoveLink);
    document
      .getElementById(this.drid)
      .addEventListener("paste", this.handlePaste);
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.scroll);
    document.removeEventListener("click", this.showRemoveLink);
    document.removeEventListener("keydown", this.handleHitEnter, true);
  },

  methods: {
    syncHTML() {
      if (this.html !== this.$refs[this.drid].innerHTML)
        this.innerHTML = this.html;
    },

    emit() {
      this.$emit("html", this.$refs[this.drid].innerHTML);
      this.$emit("change", this.$refs[this.drid].innerHTML);
    },

    onInput: debounce(function() {
      this.emit();
    }, 300),

    handleHitEnter(e) {
      const ENTER_KEY_CODE = 13;
      if (
        e.target.id === this.drid &&
        (e.key === "Enter" || e.keyCode === ENTER_KEY_CODE)
      ) {
        e.stopPropagation();
      }
    },

    handlePaste(e) {
      var clipboardData, pastedData;

      // Stop data actually being pasted into div
      e.stopPropagation();
      e.preventDefault();

      // Get pasted data via clipboard API
      clipboardData = e.clipboardData || window.clipboardData;

      pastedData = clipboardData.getData("text/html");
      // text/html cannot retrieve plain text
      if (pastedData === "") {
        pastedData = clipboardData.getData("text/plain");
      }
      let sanitizedHtml = sanitizeHTML(pastedData, {
        allowedTags: [
          "b",
          "i",
          "em",
          "strong",
          "a",
          "h2",
          "h3",
          "h4",
          "ul",
          "ol",
          "pre",
          "br",
          "p",
          "div"
        ]
      });

      // insert that plain text text manually
      document.execCommand("insertHTML", false, sanitizedHtml);
      // Do whatever with pasteddata
      // this.insertText(pastedData);

      this.$nextTick(this.emit);

      // alert(pastedData);
    },
    showRemoveLink(e) {
      let editor = document.getElementById(this.drid);

      const clickedInEditor = editor.contains(e.target);

      if (clickedInEditor) {
        // Check to see if the clicked item is in an achor tag
        let sel = rangy.getSelection();
        let anchorNode = sel.anchorNode.parentNode;
        if (anchorNode.nodeName === "A") {
          this.cursorToolbar = true;
        } else {
          this.cursorToolbar = false;
        }
      }
    },
    clearContent() {
      document.getElementById(this.drid).innerHTML = "";
    },
    setContent(content) {
      document.getElementById(this.drid).innerHTML = content;
    },
    scroll: function() {
      // var h = document.getElementById('someDiv').clientHeight;
      // var h = document.getElementById('someDiv').offsetHeight;
      // var h = document.getElementById('someDiv').scrollHeight;

      // This is how far the editor is from the top of the visible window
      let distance_fromTop = document
        .getElementById(this.drid)
        .getBoundingClientRect().top;

      let editorHeight = document.getElementById(this.drid).offsetHeight;
      let extraHeight = distance_fromTop + editorHeight;

      // If the editor is starting to become invisible, and
      // if we have not scrolled pass the editor, add the class
      // that causes the tools to be fixed to the top of the window
      if (distance_fromTop < 100 && extraHeight > 0) {
        var scrollTop =
          window.pageYOffset ||
          (
            document.documentElement ||
            document.body.parentNode ||
            document.body
          ).scrollTop;
        this.scrollTop = scrollTop + "px";
        // this.fixedToolbar = 'fixed';
        // document.body.classList.add("down");
      } else {
        this.scrollTop = "initial";
        // this.fixedToolbar = '';
        // document.body.classList.remove("down");
      }
    },

    // When the user clicks the button to open the popup to enter
    // the URL, run this function to save the location of ther user's
    // selection and the selected text.
    toggleLinkPopup(e) {
      e.stopPropagation(); // stop outside click from closing dropdown
      if (this.savedSel) {
        rangy.removeMarkers(this.savedSel);
      }
      // Save the location of the selected text
      this.savedSel = rangy.saveSelection();
      // Save the selected text
      this.savedSelText = rangy.getSelection().toString();
      this.showLinkPopup = true;
    },

    // Run this when the user clicks Okay to enter the URL
    insertAnchor: function() {
      // Restore the user's selected text. This is necessary since
      // the selection is lost when the user stars entering text.
      if (this.savedSel) {
        rangy.restoreSelection(this.savedSel, true);
        this.savedSel = null;
      }
      // Surround the selected text with the anchor element
      var sel = rangy.getSelection();

      var range = sel.rangeCount ? sel.getRangeAt(0) : null;
      if (range) {
        // Create the new anchor element
        var el = document.createElement("a");
        el.href = this.anchorHref;
        el.innerHTML = this.savedSelText;
        if (this.checked) {
          el.target = "_blank";
        }
        // Delete the originally selected text
        range.deleteContents();
        // Insert the anchor tag
        range.insertNode(el);
        // Ensure that the caret appears at the end
        sel.removeAllRanges();
        range = range.cloneRange();
        range.selectNode(el);
        range.collapse(false);
        sel.addRange(range);
        this.showLinkPopup = false;
      }
      this.$nextTick(this.emit);
    },
    showCodeInserter(e) {
      e.stopPropagation(); // stop outside click from closing dropdown
      this.showCode = true;
      this.savedSel = rangy.saveSelection();
    },
    // Run this when the user clicks Okay to enter the URL
    insertCode: function() {
      // Restore the user's selected text. This is necessary since
      // the selection is lost when the user stars entering text.
      if (this.savedSel) {
        rangy.restoreSelection(this.savedSel, true);
        this.savedSel = null;
      }
      // Surround the selected text with the anchor element
      var sel = rangy.getSelection();

      var range = sel.rangeCount ? sel.getRangeAt(0) : null;
      if (range) {
        var codeBlock = document.getElementById("codeBlock");

        const codeBlockContent = codeBlock.value;

        codeBlock.value = "";

        var el = document.createElement("pre");

        el.innerText = codeBlockContent;

        el.className = "EnlighterJSRAW";

        let id = "code-" + Date.now();
        el.id = id;

        document.execCommand("insertHTML", false, el.outerHTML);

        let insertedEl = document.getElementById(id);

        // Move the caret outside of the pre
        range = document.createRange(); //Create a range (a range is a like the selection but invisible)
        range.selectNodeContents(insertedEl); //Select the entire contents of the element with the range
        range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
        let selection = window.getSelection(); //get the selection object (allows you to change selection)
        selection.removeAllRanges(); //remove any selections already made
        selection.addRange(range); //make the range you have just created the visible selection

        document.execCommand("insertHTML", false, "<div></div>");

        // // Delete the originally selected text
        // range.deleteContents();
        // // Insert the anchor tag
        // range.insertNode(el);
        // // Ensure that the caret appears at the end
        // sel.removeAllRanges();
        // range = range.cloneRange();
        // range.selectNode(el);
        // range.collapse(false);
        // sel.addRange(range);
        this.showCode = false;
      }
      this.$nextTick(this.emit);
    },

    insertText: function(pastedText) {
      // Restore the user's selected text. This is necessary since
      // the selection is lost when the user stars entering text.
      if (this.savedSel) {
        rangy.restoreSelection(this.savedSel, true);
        this.savedSel = null;
      }

      var sel = rangy.getSelection();

      var range = sel.rangeCount ? sel.getRangeAt(0) : null;
      if (range) {
        var el = document.createElement("div");

        el.innerText = pastedText;

        // Delete the originally selected text
        range.deleteContents();
        // Insert the anchor tag
        range.insertNode(el);
        // Ensure that the caret appears at the end
        sel.removeAllRanges();
        range = range.cloneRange();
        range.selectNode(el);
        range.collapse(false);
        sel.addRange(range);
        this.showCode = false;
      }
    },
    removeAnchor(e) {
      let sel = rangy.getSelection();

      let editor = document.getElementById(this.drid);

      // let elementBound = this.getSelectionBoundaryElement();

      // This is the anchor tag node with the text in it
      let anchorNode = sel.anchorNode.parentNode;

      // This is the text node
      let anchorTextNode = sel.anchorNode;

      // First, make sure that the selected element
      // is inside the editor
      const clickedInEditor = editor.contains(anchorTextNode);

      if (!clickedInEditor) {
        return;
      }

      anchorNode.parentNode.removeChild(anchorNode);

      var range = sel.getRangeAt(0);

      range.insertNode(anchorTextNode);

      // Ensure that the caret appears at the end
      sel.removeAllRanges();
      range = range.cloneRange();
      range.selectNode(anchorTextNode);
      range.collapse(false);
      sel.addRange(range);

      this.cursorToolbar = false;

      this.$nextTick(this.emit);
    },

    focusOnInput: function() {
      document.getElementById("anchorHref").focus();
    }
  },
  computed: {
    innerHTML: {
      get() {
        return this.$refs[this.drid].innerHTML;
      },

      set(html) {
        if (this.$refs[this.drid].innerHTML !== html) {
          this.$refs[this.drid].innerHTML = html;
        }
      }
    }
  }
};
</script>

<style lang="scss">
.dir-card__facets {
  font-weight: 600;
  font-size: 15px;
  line-height: 14px;
  line-height: 16px;
  margin-bottom: 5px !important;
}

// #linkInserter {
//     display: none;
// }
.dre-toolbar-popup.false {
  display: none;
}

.unselectable {
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.dre-btn {
  font-size: 12px;
  border: 1px solid #c1c1c1;
  padding: 2px 6px;
  background: white;
}

.dre-btn:hover {
  cursor: pointer;
}

.dre-toolbar-popup {
  position: absolute;
  z-index: 7;
  padding-top: 0;
  left: 0;
  font-size: 14px;
  line-height: 14px !important;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(0, 0, 0, 0.2);
}

.cursor-toolbar {
  display: none;
}

.cursor-toolbar.true {
  display: inline-block;
}

#linkInserter {
  padding: 10px;
}

.dreditor {
  background: white;
  padding: 5px 10px;
  border: 2px solid #e9e9e9;
  border-radius: 3px;
  min-height: 67px;
}

#linkSection {
  position: absolute;
}

#linkSection.fixed {
  position: fixed;
  top: 0px;
}

.dreditor {
  padding-top: 30px;
  pre {
    overflow-x: scroll;
  }
  a {
    color: #418da6;
    cursor: pointer;
  }
}
</style>
